export default function Home() {
    return (
        <footer className="footer">Copyright 2022 © BBOLD JSC - All rights reserved.</footer>
    )
}